// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"cb61e803","359":"0bdd3340"}[chunkId] + ".chunk.js";
};